/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Input, FormGroup } from "reactstrap";

const ExpirationFields = ({ card, setCard, invalid }) => {
  const expirationArray = ["", "/", ""];

  const handleMonthFormatting = e => {
    const numbers = e.target.value.match(/\d+/g);
    const formatted = numbers !== null ? numbers.join("").slice(0, 2) : numbers;

    setCard({
      ...card,
      ...{
        mmExpiration: formatted || ""
      }
    });
  };
  const handleYearFormatting = e => {
    const numbers = e.target.value.match(/\d+/g);
    const formatted = numbers !== null ? numbers.join("").slice(0, 2) : numbers;

    setCard({
      ...card,
      ...{
        yyExpiration: formatted || ""
      }
    });
  };

  useEffect(() => {
    const buildExpirationString = () => {
      expirationArray.splice(0, 1, card.mmExpiration);
      expirationArray.splice(2, 1, card.yyExpiration);

      const expirationString = expirationArray[0].concat(
        expirationArray[1].concat(expirationArray[2])
      );

      return expirationString;
    };

    const handleExpirationChange = () => {
      setCard({
        ...card,
        ...{
          expiration: buildExpirationString()
        }
      });
    };
    handleExpirationChange();
  }, [card.mmExpiration, card.yyExpiration, card.expiration]);

  return (
    <>
      <FormGroup className="expiration-form">
        <Input
          aria-label="input month expiration date"
          id="mm-input"
          type="text"
          placeholder="MM"
          required
          value={card.mmExpiration}
          onChange={e => {
            handleMonthFormatting(e);
          }}
          onFocus={e => setCard({ ...card, focus: e.target.name })}
          data-private="redact"
          invalid={invalid}
        />
      </FormGroup>
      <p className="mmyySlash" id="mmyySlash">
        /
      </p>
      <FormGroup className="expiration-form">
        <Input
          aria-label="input year expiration date"
          id="yy-input"
          type="text"
          placeholder="YY"
          required
          value={card.yyExpiration}
          onChange={e => {
            handleYearFormatting(e);
          }}
          onFocus={e => setCard({ ...card, focus: e.target.name })}
          data-private="redact"
          invalid={invalid}
        />
      </FormGroup>
    </>
  );
};

export default ExpirationFields;

ExpirationFields.propTypes = {
  card: PropTypes.object,
  setCard: PropTypes.func,
  invalid: PropTypes.bool
};

ExpirationFields.defaultProps = {
  card: undefined,
  setCard: undefined,
  invalid: undefined
};
